import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";
import { injectIntl, intlShape } from "react-intl";

import { genComponentFormatterLong } from "../model/util/Components";

import { genDailyMessage } from "./DailyValuesHelpers";
import { checkDailyProps } from "../model/util/DailyValues";

class MotorstartsTabelle extends React.Component {

	static propTypes = {
		model: PropTypes.object.isRequired,
		timespan: PropTypes.object.isRequired,
		rtc: PropTypes.string.isRequired,
		compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
		units: PropTypes.object.isRequired,
		intl: intlShape.isRequired,
		refresh: PropTypes.func.isRequired
	};
	
	constructor(props, context) {
		super(props, context);
		this.state = {};
		checkDailyProps(props);
	}
	componentWillReceiveProps(nextProps) {
		checkDailyProps(nextProps);
	}
	render() {
		const { model, compressors, intl } = this.props;
		return (
			<div>
				<Table.Provider
					className="printableAlmigItem"
					columns={[{
						property: "cindex",
						cell: { formatters: [ genComponentFormatterLong(compressors, intl) ] },
						header: {
							label: intl.formatMessage({ id: "Component" })
						}
					}, {
						property: "motorstarts",
						header: {
							label: intl.formatMessage({ id: "Motor starts" })
						}
					}]}>
					<Table.Header />
					<Table.Body rows={model.data} rowKey="cindex" />
				</Table.Provider>
				{genDailyMessage(model)}
			</div>
		);
	}
}

export default injectIntl(MotorstartsTabelle);
